module.exports = __webpack_public_path__ + "img/GAME_GUKHWAPPANG2.e07d6a75.jpg";